<template>
    <GridButton
        v-if="!contestant"
        :row="row"
        text="general.registercontestant"
        icon="fa-user-plus"
        :onClick="onClick"
    ></GridButton>
    <span
        class="text-success"
        v-else-if="(contestant?.Bib ?? 0) > 0"
        v-html="$ti('participant.registered', { bib: contestant?.Bib }, true)"
    ></span>
    <span
        class="text-info"
        v-else
        v-html="$tm('participant.registeredwithoutbib')"
    ></span>
</template>
<script lang="ts" setup>
import { GridButton } from '@/components';
import { $ti } from '@/locize';
import type { Participant } from '@/objects/generated';
import { useContestantStore } from '@/stores';
import { computed, ref } from 'vue';

const props = defineProps<{
    /**
     * The participant id
     */
    value: number | null;

    /**
     * The participant row to display the button for
     */
    row: Participant;
    /**
     * The participant to register
     */
    onClick: (row: Participant) => void;
}>();
const bla = ref(null);

const contestant = computed(() => {
    if (props.value == null) {
        return null;
    }
    return useContestantStore().GetContestantByParticipantId(props.value);
});
</script>
